import { Card, CardContent, CardHeader } from '@eigtech/ui/components/card'
import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { createFileRoute } from '@tanstack/react-router'
import { TypographyH4 } from '@eigtech/ui/components/typopgraphy'
import { InspectionsTable } from '@eigtech/ui-shared-inspections-web'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/inspections')({
  component: RouteComponent,
})

function RouteComponent() {
  const { claimNumber } = Route.useParams()

  return (
    <Card>
      <CardHeader>
        <TypographyH4>Inspections</TypographyH4>
      </CardHeader>
      <CardContent>
        <InspectionsTable entityId={ensureClaimCorn(claimNumber)} />
      </CardContent>
    </Card>
  )
}
